// 因为 APP 调用 JS 的方法时可能 WebView 没宽高
// 此时将调用缓存起来，检测到有宽高时再次调用
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let callbackCache: (() => void)[] = [];
let detectHandler: number;

function detect() {
  if (detectHandler) {
    clearTimeout(detectHandler);
  }
  const baseMapContainer = document.getElementById("diduoduo_draw_container");

  if (process.env.NODE_ENV === "development") {
    console.log(
      "container size",
      baseMapContainer?.clientHeight,
      baseMapContainer?.clientWidth
    );
  }

  if (
    baseMapContainer &&
    baseMapContainer.clientHeight > 0 &&
    baseMapContainer.clientWidth > 0
  ) {
    try {
      callbackCache.forEach((cb) => cb());
    } catch (e) {
      console.error(e);
    }
    callbackCache = [];
  } else {
    // 当没有宽高时，每隔 3 秒检测一次
    detectHandler = setTimeout(() => {
      detect();
    }, 3000);
  }
}

/**
 * 调用某个方法直到容器有宽高
 * @param callback
 */
export function invokeUtilContainerHasSize(callback: () => void) {
  callbackCache.push(callback);
  detect();
}
